<i18n>
{
  "fr": {
    "admin": {
      "datasource": {
        "observation-point-title": "Point d'observation",
        "datasource-list-title": "Sources de données",
        "general-info-title": "Information générale sur la source de données",
        "action": "Actions",
        "search-datasource-placeholder": "Rechercher une source de données",
        "datasource-id": "ID",
        "parameter-type-name": "Paramètre mesuré",
        "datasource-type-name": "Type de source de données",
        "datasource-working-state": "Etat de fonctionnement",
        "datasource-can-aggregate": "Aggrégation temporelle disponible",
        "remote-enabled-true": "Télétransmission activée",
        "remote-enabled-false": "Télétransmission désactivée",
        "data": {
          "title": "Données",
          "event": "Date",
          "value": "Valeur",
          "quality": "Code qualité",
          "remark": "Remarque",
          "measure-type": "Type mesure",
          "temporal-reference": "Ref. temporelle",
          "correction-method": "Methode corr.",
          "confirm-add-remote-dialog-title": "Sources de données supplémentaires requises",
          "confirm-add-remote-dialog-desc": "Pour activer la télétransmission des sources de données seront ajoutées. Voulez-vous poursuivre ?",
          "add-datasources": "Ajouter les sources de données",
          "create-dialog-title": "Ajouter une valeur",
          "update-dialog-title": "Modifier une valeur",
          "create-submit": "Ajouter",
          "update-submit": "Modifier",
          "date": "Date (Format: DD.MM.YYYY)",
          "time": "Heure (Format: HH:mm:SS)",
          "add-value-tooltip": "Ajouter une valeur",
          "update-value-tooltip": "Modifier cette valeur",
          "delete-value-tooltip": "Supprimer cette valeur",
          "confirm-delete-title": "Confirmer la suppression",
          "confirm-delete-content": "Voulez-vous supprimer cette valeur ? Cette opération peut entraîner le rafraîchissement des produits calculés.",
          "update-in-progress": "Modification en cours..."
        },
        "max-data-count-reached": "La source de données est trop grande pour être traitée ici ({count} entrées). L'édition est limitée à {limit} entrées.",
        "empty-data": "Pas de données.",
        "return-to-list": "Vers la liste des points d'observation",
        "goto-data": "Accéder aux données"
      }
    },
    "data": {
      "temporal-reference-value": {
        "unknown": "Inconnue",
        "UTC": "UTC",
        "UTC+1": "UTC+1",
        "UTC+2": "UTC+2",
        "legal": "Heure légale (Europe / Zurich)"
      },
      "quality-value": {
        "unknown": "Inconnue",
        "not_validated": "Non validée (Code 0)",
        "validated": "Validée (Code 1)",
        "to_check": "A contrôler (Code 2)",
        "corrected": "Corrigée (Code 3)",
        "reconstituted": "Reconstituée (Code 4)",
        "unreliable": "Douteuse (Code 5)"
      },
      "measure-type-value": {
        "null": "Null",
        "unknown": "Inconnue",
        "manual": "Manuelle (Code M)",
        "auto_digital": "Auto. digitale (Code D)",
        "auto_digitized": "Auto. digitalisée (Code G)",
        "auto_teletransmitted": "Auto. télétransmise (Code T)"
      }
    },
    "observation-point": {
      "field": {
        "oid": "Identifiant DB",
        "id": "ID",
        "publicId": "ID cantonal",
        "name": "Nom",
        "coords": "Coordonnées",
        "coord-x": "Coordonnée X",
        "coord-y": "Coordonnée Y"
      }
    },
    "common": {
      "close": "Fermer",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "ok": "ok",
      "options": "Options"
    },
    "update-remote-title": "Succès",
    "update-remote-message": "L'état de la télétransmission a été mis à jour",
    "error-update-remote-title": "Erreur",
    "error-update-remote-message": "Une erreur s'est produite lors de la mise à jour de l'état de la télétransmission. Veuillez réessayer."
  },
  "de": {

  }
}
</i18n>


<template>
  <div class="admin with-left-bar observation-point" v-if="!loading">
    <div class="left-panel">
      <div class="no-background">
        <md-button class="md-icon-button md-dense md-raised" @click="gotoObsPointList()">
          <md-icon>arrow_back</md-icon>
          <md-tooltip>{{ $t('admin.datasource.return-to-list') }}</md-tooltip>
        </md-button>
      </div>
      <div class="observation-point-container">
        <h3>{{ $t('admin.datasource.observation-point-title') }}</h3>
        <div class="observation-point-info">
          <md-field>
            <label>{{ $t('observation-point.field.id') }}</label>
            <md-input :disabled="true" v-model="observationPoint.id"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('observation-point.field.name') }}</label>
            <md-input :disabled="true" v-model="observationPoint.name"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('observation-point.field.publicId') }}</label>
            <md-input :disabled="true" v-model="observationPoint.publicId"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('observation-point.field.coord-x') }}</label>
            <md-input :disabled="true" v-model="observationPoint.geom.coordinates[0]"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('observation-point.field.coord-y') }}</label>
            <md-input :disabled="true" v-model="observationPoint.geom.coordinates[1]"></md-input>
          </md-field>
          <md-switch @change="toggleRemote" class="md-primary" v-model="observationPoint.remoteEnabled"> {{
    $t(`admin.datasource.remote-enabled-${observationPoint.remoteEnabled}`) }}</md-switch>
        </div>
      </div>
      <div class="datasource-list-container">
        <h3>{{ $t('admin.datasource.datasource-list-title') }}</h3>
        <div class="search-input">
          <md-field>
            <md-input v-model="searchTermsDatasource"
              :placeholder="$t('admin.datasource.search-datasource-placeholder')"></md-input>
            <div>
              <md-icon>search</md-icon>
              <md-tooltip>{{ $t('search') }}</md-tooltip>
            </div>
          </md-field>
        </div>
        <md-content class="datasource-list md-scrollbar">
          <div :class="['datasource', 'md-elevation-2', { 'selected': datasource.selected }]"
            v-for="datasource in filtredDatasources" :key="datasource.id" @click="toggleSelectedDatasource(datasource)">
            <div class="parameter-type">
              <span class="parameter-type-name">{{ datasource.parameterType.name[$i18n.locale] }}</span>
              <span class="parameter-type-code">{{ datasource.parameterType.code }}</span>
            </div>
            <span class="datasource-type-name">{{ datasource.datasourceType.name[$i18n.locale] }}</span>
          </div>
        </md-content>
      </div>
      <div class="no-background show-timeseries">
        <md-button class="md-raised" @click="gotoTimeseries()">{{ $t('admin.datasource.goto-data') }}</md-button>
      </div>
    </div>
    <div class="main-panel" v-if="selectedDatasource !== null">
      <div class="general-info-container">
        <h3>{{ $t('admin.datasource.general-info-title') }}</h3>
        <div class="datasource-info">
          <md-field>
            <label>{{ $t('admin.datasource.datasource-id') }}</label>
            <md-input :disabled="true" v-model="selectedDatasource.id"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.parameter-type-name') }}</label>
            <md-input :disabled="true" v-model="selectedDatasource.parameterType.name[$i18n.locale]"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.datasource-type-name') }}</label>
            <md-input :disabled="true" v-model="selectedDatasource.datasourceType.name[$i18n.locale]"></md-input>
          </md-field>
        </div>
      </div>
      <div class="data-preview-container">
        <h3 class="data-preview-title" v-if="!loadingData">
          {{ $t('admin.datasource.data.title') }}
          <md-button class="md-icon-button md-dense md-raised" @click="addData()" v-if="data !== null">
            <md-icon>add</md-icon>
            <md-tooltip>{{ $t('admin.datasource.data.add-value-tooltip') }}</md-tooltip>
          </md-button>
        </h3>
        <div class="loading" v-if="loadingData">
          <md-progress-spinner class="loading-animation" :md-diameter="40" :md-stroke="5"
            md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div v-if="data === null">
          <p>{{ $t('admin.datasource.max-data-count-reached', {
    limit: limitDatasourceCount, count:
      selectedDatasource.stats.count
  }) }}</p>
        </div>
        <div v-if="data !== null && data.length === 0">
          <p>{{ $t('admin.datasource.empty-data') }}</p>
        </div>
        <md-table v-if="!loadingData && data !== null && data.length > 0">
          <md-table-row>
            <md-table-head>{{ $t('admin.datasource.data.event') }} ({{ utcOffsetDisplay }})</md-table-head>
            <md-table-head>{{ $t('admin.datasource.data.temporal-reference') }}</md-table-head>
            <md-table-head>{{ $t('admin.datasource.data.value') }} [{{
    selectedDatasource.parameterType.unit.symbol[$i18n.locale] }}]</md-table-head>
            <md-table-head>{{ $t('admin.datasource.data.quality') }}</md-table-head>
            <md-table-head>{{ $t('admin.datasource.data.measure-type') }}</md-table-head>
            <md-table-head>{{ $t('admin.datasource.data.remark') }}</md-table-head>
            <md-table-head>{{ $t('common.options') }}</md-table-head>
          </md-table-row>
          <md-table-row v-for="d in data" :key="d.event">
            <md-table-cell>{{ d.event | formatDatetime(userUtcOffset) }}</md-table-cell>
            <md-table-cell>{{ $t(`data.temporal-reference-value.${d.temporalReference}`) }}</md-table-cell>
            <md-table-cell>{{ d.value | formatValue }}</md-table-cell>
            <md-table-cell>{{ $t(`data.quality-value.${d.quality}`) }}</md-table-cell>
            <md-table-cell>{{ $t(`data.measure-type-value.${d.measureType}`) }}</md-table-cell>
            <md-table-cell>{{ d.remark }}</md-table-cell>
            <md-table-cell>
              <md-button class="md-icon-button md-dense" @click="editData(d)">
                <md-icon>edit</md-icon>
                <md-tooltip>{{ $t('admin.datasource.data.update-value-tooltip') }}</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-dense" @click="confirmDeleteData(d)">
                <md-icon>delete_forever</md-icon>
                <md-tooltip>{{ $t('admin.datasource.data.delete-value-tooltip') }}</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <!-- <div class="action-container">
        <h3>{{ $t('admin.datasource.action') }}</h3>
      </div> -->
    </div>
    <md-dialog :md-active="showEditData" v-if="dataToEdit !== null" class="edit-value-dialog">
      <md-dialog-title>{{ $t(`admin.datasource.data.${editDataMode}-dialog-title`) }}</md-dialog-title>

      <md-dialog-content>
        <div class="datetime-selection">
          <md-field>
            <label>{{ $t('admin.datasource.data.date') }}</label>
            <md-input v-model="dataToEdit.date" required></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.data.time') }}</label>
            <md-input v-model="dataToEdit.time" required></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.data.temporal-reference') }}</label>
            <md-select v-model="dataToEdit.temporalReference" required>
              <md-option value="unknown">{{ $t('data.temporal-reference-value.unknown') }}</md-option>
              <md-option value="UTC">{{ $t('data.temporal-reference-value.UTC') }}</md-option>
              <md-option value="UTC+1">{{ $t('data.temporal-reference-value.UTC+1') }}</md-option>
              <md-option value="UTC+2">{{ $t('data.temporal-reference-value.UTC+2') }}</md-option>
              <md-option value="legal">{{ $t('data.temporal-reference-value.legal') }}</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="info-selection">
          <md-field>
            <label>{{ $t('admin.datasource.data.value') }} [{{
    selectedDatasource.parameterType.unit.symbol[$i18n.locale] }}]</label>
            <md-input v-model="dataToEdit.value" type="number" step="0.01" required></md-input>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.data.quality') }}</label>
            <md-select v-model="dataToEdit.quality" required>
              <md-option value="not_validated">{{ $t('data.quality-value.not_validated') }}</md-option>
              <md-option value="validated">{{ $t('data.quality-value.validated') }}</md-option>
              <md-option value="to_check">{{ $t('data.quality-value.to_check') }}</md-option>
              <md-option value="corrected">{{ $t('data.quality-value.corrected') }}</md-option>
              <md-option value="reconstituted">{{ $t('data.quality-value.reconstituted') }}</md-option>
              <md-option value="unreliable">{{ $t('data.quality-value.unreliable') }}</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.data.measure-type') }}</label>
            <md-select v-model="dataToEdit.measureType" required>
              <md-option value="manual">{{ $t('data.measure-type-value.manual') }}</md-option>
              <md-option value="auto_digital">{{ $t('data.measure-type-value.auto_digital') }}</md-option>
              <md-option value="auto_digitized">{{ $t('data.measure-type-value.auto_digitized') }}</md-option>
              <md-option value="auto_teletransmitted">{{ $t('data.measure-type-value.auto_teletransmitted')
                }}</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label>{{ $t('admin.datasource.data.remark') }}</label>
            <md-input v-model="dataToEdit.remark" maxlength="5"></md-input>
          </md-field>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showEditData = false">{{ $t('common.cancel') }}</md-button>
        <md-button class="md-primary md-raised" @click="addOrUpdateData()">{{
    $t(`admin.datasource.data.${editDataMode}-submit`) }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active="showNoRemoteDatasources" class="confirm-add-remote-dialog">
      <md-dialog-title>{{ $t(`admin.datasource.data.confirm-add-remote-dialog-title`) }}</md-dialog-title>

      <md-dialog-content>
        <p>{{ $t(`admin.datasource.data.confirm-add-remote-dialog-desc`) }}</p>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showNoRemoteDatasources = false">{{ $t('common.cancel') }}</md-button>
        <md-button class="md-primary md-raised" @click="addRemoteDatasources()">{{
    $t(`admin.datasource.data.add-datasources`) }}</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-dialog-confirm :md-active.sync="showConfirmDelete" :md-title="$t('admin.datasource.data.confirm-delete-title')"
      :md-content="$t('admin.datasource.data.confirm-delete-content')" :md-confirm-text="$t('common.delete')"
      :md-cancel-text="$t('common.cancel')" @md-cancel="onDeleteDataCanceled" @md-confirm="deleteData" />

    <md-dialog :md-active="updatingData" class="updating-progress-modal">
      <md-dialog-title>{{ $t(`admin.datasource.data.update-in-progress`) }}</md-dialog-title>

      <md-dialog-content>
        <md-progress-spinner class="loading-animation" :md-diameter="40" :md-stroke="5"
          md-mode="indeterminate"></md-progress-spinner>
      </md-dialog-content>

    </md-dialog>

    <md-dialog-alert :md-active.sync="dialog.show" :md-title="dialog.title" :md-content="dialog.content" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import ObservationPointProxy from '@/proxies/observationPoint'
import TimeseriesProxy from '@/proxies/timeseries'
import TimeStoreMixin from '@/mixins/store/time'

const LIMIT_DATASOURCE_COUNT = 300

export default {
  name: 'ObservationPointDatasourceAdmin',
  mixins: [
    TimeStoreMixin
  ],
  data() {
    return {
      loading: true,
      observationPoint: null,
      searchTermsDatasource: '',
      selectedDatasource: null,
      data: [],
      loadingData: false,
      showEditData: false,
      showNoRemoteDatasources: false,
      editDataMode: 'update',
      dataToEdit: null,
      showConfirmDelete: false,
      dataToDelete: null,
      updatingData: false,
      dialog: {
      show: false,
      title: '',
      content: ''
    }
    }
  },
  filters: {
    formatValue (val) {
      if (val === null) return '-'
      return parseFloat(val).toFixed(2)
    }
  },
  watch: {
    selectedDatasource () {
      this.loadData()
    }
  },
  computed: {
    observationPointId () {
      return parseInt(this.$route.params.id)
    },
    availableDatasources () {
      return this.observationPoint.datasources.filter((datasource) => datasource.accessRights.includes('write'))
    },
    filtredDatasources () {
      if (this.observationPoint === null) return []
      if (this.searchTermsDatasource === '') return this.availableDatasources
      return this.availableDatasources.filter((datasource) => {
        return datasource.parameterType.name[this.$i18n.locale].toLowerCase().includes(this.searchTermsDatasource.toLowerCase()) ||
        datasource.parameterType.code.toLowerCase().includes(this.searchTermsDatasource.toLowerCase()) ||
        datasource.datasourceType.name[this.$i18n.locale].toLowerCase().includes(this.searchTermsDatasource.toLowerCase())
      })
    },
    limitDatasourceCount () {
      return LIMIT_DATASOURCE_COUNT
    }
  },
  mounted () {
   this.loadObservationPoint()
  },
  methods: {
    loadObservationPoint(){
      ObservationPointProxy.get(this.observationPointId).then((observationPoint) => {
        this.observationPoint = observationPoint
        if (this.observationPoint.datasources.length > 0) this.toggleSelectedDatasource(_.head(this.observationPoint.datasources))
        this.loading = false
      }).catch(this.handleError)
    },
    showUpdateRemoteSuccess(){
      this.dialog.title = this.$t('update-remote-title')
      this.dialog.content = this.$t('update-remote-message')
      this.dialog.show = true
    },
    showUpdateRemoteError(){
      this.dialog.title = this.$t('error-update-remote-title')
      this.dialog.content = this.$t('error-update-remote-message')
      this.dialog.show = true
    },
  
    toggleSelectedDatasource (datasource) {
      if (this.selectedDatasource !== null) {
        this.selectedDatasource.selected = false
        this.$set(this.observationPoint.datasources, this.observationPoint.datasources.indexOf(this.selectedDatasource), this.selectedDatasource)
        if (datasource.id === this.selectedDatasource.id) return this.selectedDatasource = null
      }
      datasource.selected = true
      this.selectedDatasource = datasource
      this.$set(this.observationPoint.datasources, this.observationPoint.datasources.indexOf(datasource), this.selectedDatasource)
    },
    async addRemoteDatasources(){
      try {
          this.showNoRemoteDatasources = false;
          this.updatingData = true
          await ObservationPointProxy.addDatasourceRemote(this.observationPoint.id)
          this.loadObservationPoint()
          this.updatingData = false   
          this.showUpdateRemoteSuccess();
      } catch (error){
        this.updatingData = false   
        this.showUpdateRemoteError()
      }
    },
    async toggleRemote(){
      let hasRemoteDatasource = !!this.observationPoint.datasources.find(ds => ds.datasourceType.code === 'remote')
      try {
        if(hasRemoteDatasource){
          await ObservationPointProxy.updateRemote(this.observationPoint.id, this.observationPoint.remoteEnabled)
          this.showUpdateRemoteSuccess()
        } else {
          this.observationPoint.remoteEnabled = false
          this.showNoRemoteDatasources = true
        }
       
      } catch (error){
        this.showUpdateRemoteError()
      }
    },
    loadData () {
      if (this.loadingData) return
      if (this.selectedDatasource === null || this.selectedDatasource.stats.maxDate === null) {
        this.data = []
        return
      }
      if (this.selectedDatasource.stats.count > LIMIT_DATASOURCE_COUNT) {
        this.data = null
        return
      }

      this.loadingData = true
      // Attention ! Récupération de l'entier de la chronique.
      TimeseriesProxy.extract({
        datasourceId: this.selectedDatasource.id,
        dateFrom: moment.utc('1900-01-01'),
        dateTo: moment.utc().toISOString()
      }).then((data) => {
        this.data = _.orderBy(data, 'event', 'desc')
        this.loadingData = false
      })
    },
    addData () {
      // Valeur par défaut
      this.dataToEdit = {
        temporalReference: 'legal',
        quality: 'validated',
        measureType: 'manual',
        correctionMethod: null,
        remark: ''
      }
      this.editDataMode = 'create'
      this.showEditData = true
    },
    editData (tuple) {
      this.dataToEdit = tuple
      this.dataToEdit.value = this.dataToEdit.value === null ? null : parseFloat(this.dataToEdit.value).toFixed(2)
      this.dataToEdit.originalEvent = _.clone(this.dataToEdit.event)
      // Extraction du temps en assignant la timezone
      switch(this.dataToEdit.temporalReference) {
        case 'unknown':
        case 'legal':
          this.dataToEdit.date = moment.utc(this.dataToEdit.event).tz('Europe/Zurich').format('DD.MM.YYYY')
          this.dataToEdit.time = moment.utc(this.dataToEdit.event).tz('Europe/Zurich').format('HH:mm:SS')
          break
        case 'UTC':
          this.dataToEdit.date = moment.utc(this.dataToEdit.event).utcOffset(0).format('DD.MM.YYYY')
          this.dataToEdit.time = moment.utc(this.dataToEdit.event).utcOffset(0).format('HH:mm:SS')
          break
        case 'UTC+1':
          this.dataToEdit.date = moment.utc(this.dataToEdit.event).utcOffset(60).format('DD.MM.YYYY')
          this.dataToEdit.time = moment.utc(this.dataToEdit.event).utcOffset(60).format('HH:mm:SS')
          break
        case 'UTC+2':
          this.dataToEdit.date = moment.utc(this.dataToEdit.event).utcOffset(120).format('DD.MM.YYYY')
          this.dataToEdit.time = moment.utc(this.dataToEdit.event).utcOffset(120).format('HH:mm:SS')
          break
      }
      this.editDataMode = 'update'
      this.showEditData = true
    },
    confirmDeleteData (tuple) {
      this.dataToDelete = tuple
      this.showConfirmDelete = true
    },
    onDeleteDataCanceled () {
      this.showConfirmDelete = false
      this.dataToDelete = null
    },
    addOrUpdateData () {
      // Reformer la date suivant les paramètres définis par l'utilisateur
      this.dataToEdit.event = moment.utc(`${this.dataToEdit.date} ${this.dataToEdit.time}`, 'DD.MM.YYYY HH:mm:SS')
      // Assignation de la timezone
      switch(this.dataToEdit.temporalReference) {
        case 'unknown':
        case 'legal':
          this.dataToEdit.event.tz('Europe/Zurich', true)
          break
        case 'UTC':
          this.dataToEdit.event.utcOffset(0, true)
          break
        case 'UTC+1':
          this.dataToEdit.event.utcOffset(60, true)
          break
        case 'UTC+2':
          this.dataToEdit.event.utcOffset(120, true)
          break
      }
      this.dataToEdit.event = this.dataToEdit.event.toISOString()
      this.dataToEdit.value = parseFloat(this.dataToEdit.value)
      if (this.editDataMode === 'create'){
        this.showEditData = false
        this.updatingData = true
        TimeseriesProxy.addValue(this.selectedDatasource.id, this.dataToEdit).then(() => {
          this.updatingData = false
          this.loadData()
        }).catch(this.handleError)
      } else {
        this.showEditData = false
        this.updatingData = true
        TimeseriesProxy.updateValue(this.selectedDatasource.id, this.dataToEdit.originalEvent, this.dataToEdit).then(() => {
          this.updatingData = false
          this.loadData()
        }).catch(this.handleError)
      }
    },
    deleteData () {
      this.updatingData = true
      TimeseriesProxy.deleteValue(this.selectedDatasource.id, this.dataToDelete.event).then(() => {
          this.updatingData = false
          this.loadData()
      }).catch(this.handleError)
    },
    gotoObsPointList () {
      this.$router.push({ name: 'admin-observation-points' })
    },
    gotoTimeseries () {
      let routeData = this.$router.resolve({name: 'observation-point-data', params: { id: this.observationPointId }});
      window.open(routeData.href, '_blank');
    },
    handleError (e) {
      console.error(e)
    }
  }
}
</script>

<style lang="scss">
.datasource-info,
.datasource-stats {
  .md-field {
    width: 250px;
  }
}
</style>

<style lang="scss" scoped>
.observation-point {
  display: flex;
  height: 100vh;

  &>div {
    height: 100%;
    padding: 7px;
  }
}

.left-panel {
  width: 365px;
  background: #edebeb;

  &>div {
    background: white;
    padding: 7px;
    margin-bottom: 15px;
  }

  &>div.no-background {
    background: transparent;
  }

  .show-timeseries {
    display: flex;
    justify-content: center;
  }
}

.datasource-list-container {
  .search-input {
    margin-top: -30px;
    padding: 0px 16px 0px 6px;
    margin-bottom: -15px;
  }

  .datasource-list {
    display: flex;
    flex-direction: column;
    max-height: 290px;
    overflow: auto;
    gap: 2px;

    .datasource {
      margin: 5px;
      padding: 10px;
      user-select: none;
      cursor: pointer;

      &.selected {
        background-color: #184aa0;
        color: white;
      }

      .parameter-type {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .parameter-type-name {
        display: block;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: .005em;
      }

      .datasource-type-name,
      .parameter-type-code {
        display: block;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: .005em;
      }
    }
  }
}

.datasource-info,
.datasource-stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.data-preview-container {
  .data-preview-title {
    display: flex;
    align-items: center;
  }
}

.edit-value-dialog {
  .md-content {
    padding: 25px;
    padding-top: 0px;
  }

  .datetime-selection,
  .info-selection {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    .md-field {
      width: 250px;
    }
  }
}

.updating-progress-modal {
  .md-content {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
  }

  .md-title {
    text-align: center;
  }
}
</style>